export class MsgElm {
  component;
  divMsg;
  pixiMsg;
  pixiMsg1;
  pixiMsg2;
  msg1;
  msg2;

  constructor(component) {
    this.component = component;
  }

  setText(title, description, actualWidth, actualHeight) {
    if (this.component != null) {
      if (this.divMsg==null) {
        this.divMsg = document.createElement("DIV");
        this.divMsg.style.width = '100%';
        this.divMsg.style.height = '100%';
        this.divMsg.style.position = 'absolute';
        this.divMsg.style.top = '0px'
        this.divMsg.style.left = '0px'
        this.divMsg.style.margin = "0px 0px 0px 0px";
        this.divMsg.style.background = 'white';
        this.divMsg.style.zIndex = '999';
        this.component.nativeElement.appendChild(this.divMsg);

        this.msg1 = document.createElement("H1");

        this.msg1.style.fontSize = '16px';
        this.msg1.style.fontWeight = 'bold';
        this.msg1.style.width = '100%';
        this.msg1.style.color = 'black';
        this.msg1.style.textAlign = 'center';
        this.divMsg.appendChild(this.msg1);

        this.msg2 = document.createElement("P");

        this.msg2.style.fontSize = '10px';
        this.msg2.style.width = '100%';
        this.msg2.style.color = 'black';
        this.msg2.style.textAlign = 'center';
        this.divMsg.appendChild(this.msg2);
      }
      this.msg1.innerHTML = title;
      this.msg2.innerHTML = description;
    }
  }

  destroy(): void {
    if (this.component!=null &&  this.component.nativeElement && this.divMsg!=null) {
      try {
        this.component.nativeElement.removeChild(this.divMsg);
      } catch (e) {

      }
      this.divMsg = null;
    }
  }

}
